import { useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';

import { fg } from '@confluence/feature-gating';

import { GetLicensedProductsQuery } from '../graphql/GetLicensedProductsQuery.graphql';
import type { GetLicensedProductsQuery as GetLicensedProductsQueryType } from '../graphql/__types__/GetLicensedProductsQuery';

export const useLicensedProducts = () => {
	// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations
	const { data } = useQuery<GetLicensedProductsQueryType>(GetLicensedProductsQuery, {
		fetchPolicy: 'cache-first',
		skip: !fg('confluence_preload_tenant_license_gas'), // Skip if the feature flag is off
	});

	return useMemo(() => {
		// Early return if feature flag is off returning default behaviour
		if (!fg('confluence_preload_tenant_license_gas')) {
			return {
				hasJira: true,
				hasLoom: true,
				hasTeams: true,
			};
		}

		const licensedProducts = data?.confluence_tenantContext?.licensedProducts || [];
		return licensedProducts.reduce(
			(acc, product) => {
				if (product.licenseStatus !== 'ACTIVE') {
					return acc;
				}

				switch (product.productKey) {
					case 'jira-software':
						acc.hasJira = true;
						break;
					case 'loom':
						acc.hasLoom = true;
						break;
					case 'teams':
						acc.hasTeams = true;
						break;
					default:
						break;
				}
				return acc;
			},
			{ hasJira: false, hasLoom: false, hasTeams: false },
		);
	}, [data]);
};
